export default __webpack_public_path__ + "static/LindaOliver-2653f4c51c0f86f1d4dc2d069dc04c98.jpg";